import momentzone from 'moment-timezone';

export function currentDateTo_DDMMYYYY_Format() {
  return momentzone.tz('Australia/Melbourne').format('DD/MM/YYYY');
}

export function next7DateTo_DDMMYYY_Format() {
  return momentzone.tz('Australia/Melbourne').add(7,'days').format('DD/MM/YYYY');
}

export function currentDateTo_DDMMMYY_Format() {
  return momentzone.tz('Australia/Melbourne').format('DDMMMYY');
}

export function currentDateTo_DDMMYYY_HHMM_Format() {
  return momentzone.tz('Australia/Melbourne').format('DD/MM/YYYY HH:mm');
}

export const wait = (ms: number) => {
  return new Promise(res => setTimeout(res, ms));
};